import { CurrencyPipe, formatNumber } from '@angular/common';

export class ReportCurrencyFormatter {
  baseCurrency = localStorage.getItem("baseCurrency");
  currencyPipe = new CurrencyPipe('en');

  handleFormatter(value) {
    return this.currencyPipe.transform(value, this.baseCurrency, 'symbol');
  }

  handleNumberDecimalFormatter(value) {
    return formatNumber(value, 'en', '1.2-2');
  }

  handleNumberNonDecimalFormatter(value) {
    return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value)
  }

}


